import { mutatorAction } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
import SessionSettingsType from 'owa-service/lib/contract/SessionSettingsType';
const assign = require('object-assign');

export default mutatorAction('updateSessionSettings', function updateSessionSettings(
    newSessionSettings: SessionSettingsType
) {
    assign(getUserConfiguration().SessionSettings, newSessionSettings);
});
